import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SuccessDialogWindowComponent } from '../components/success-dialog-window/success-dialog-window.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(public dialog: MatDialog, private router: Router) {}

  openSuccessDialog(message: string, destination?: string) {
    const dialogRef = this.dialog.open(SuccessDialogWindowComponent, {
      width: '58.5rem',
      panelClass: 'custom-dialog-wrapper',
      data: { message },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (destination) {
        this.router.navigate([destination]);
      }
    });
  }
}
